import { render, staticRenderFns } from "./WellbeingPupils.vue?vue&type=template&id=656ca41d&"
import script from "./WellbeingPupils.vue?vue&type=script&lang=js&"
export * from "./WellbeingPupils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports